import React, { useCallback, useEffect, useRef, useState } from "react";

import { Col, Layout, message, Row } from "antd";

import { smallFormItemLayout, tailFormItemLayout } from "./../../utils/Layouts";

import { useSelector } from "react-redux";

import axios from "axios";
import { sumBy } from "lodash";
import moment from "moment";
import Container from "../../commons/Container";
import FormHeader from "../../commons/FormHeader";
import MemorizeTable from "../../commons/MemorizeTable";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import ReportButtons from "../../commons/ReportButtons";
import {
  authenticateAdmin,
  authenticateOwner,
} from "../../utils/authentications";
import ReportFooter from "../../utils/ReportFooter";
import ReportHeading from "../../utils/ReportHeading";
import numberFormat from "../../utils/numberFormat";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import { onBranchSearch, onWarehouseSearch } from "../../utils/utilities";
import { onChange } from "../../utils/form_utilities";

const { Content } = Layout;

const url = "/api/sales/";
const title = "Payment Method Per Sales Channel";

const initialValues = {
  period_covered: [moment().startOf("day"), moment().endOf("day")],
  branches: [],
  is_excel: false,
};
export default function PaymentMethodPerSalesChannel({
  other_set = false,
  history,
}) {
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [trans_types, setTransType] = useState([]);
  const [payment_types, setPaymentTypes] = useState([]);
  const [loading, setLoading] = useState({
    search: false,
    download: false,
  });
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const report = useRef(null);

  const getReport = useCallback(({ ...form_data }) => {
    if (form_data.period_covered) {
      setLoading({
        search: !form_data.is_excel,
        download: form_data.is_excel,
      });
      axios
        .post(`${url}payment-method-per-sales-channel`, form_data)
        .then((response) => {
          if (response.data) {
            if (form_data.is_excel) {
              return window.open(`/public/reports/${response.data.filename}`);
            }
            setRecords(response.data.records);
            setTransType(response.data.trans_types);
            setPaymentTypes(response.data.payment_types);
          }
        })
        .catch((err) => {
          message.error("There was an error processing your request");
        })
        .finally(() => {
          setLoading({
            search: false,
            download: false,
          });
        });
    } else {
      message.warning("Period Covered is Required");
    }
  }, []);

  useEffect(() => {
    let authenticate = other_set ? authenticateOwner : authenticateAdmin;

    authenticate({
      role: auth.user?.role,
      history,
    });
  }, [auth.user]);

  return (
    <Content style={{ padding: "0 50px" }}>
      <FormHeader breadcrumb_items={["Reports", title]} />
      <Container title={title}>
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              formItemLayout={smallFormItemLayout}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <SelectTagFieldGroup
              label="Branches"
              value={state.branches}
              onSearch={(value) => {
                onBranchSearch({ value, setOptions });
              }}
              onChange={(value) => {
                onChange({
                  key: "branches",
                  value,
                  setState,
                });
              }}
              formItemLayout={smallFormItemLayout}
              options={(options.branches || []).map((o) => {
                return {
                  label: o.name,
                  value: o.name,
                };
              })}
            />
          </Col>
        </Row>

        <ReportButtons
          loading={loading}
          onSearch={() => getReport({ ...state })}
          onDownload={() => getReport({ ...state, is_excel: true })}
          report={report}
          formItemLayout={tailFormItemLayout}
        />

        <div ref={report}>
          <div className="report-heading">
            <ReportHeading />
            <span className="has-text-weight-bold">{title}</span>
            <br />
            {state.period_covered?.[0] &&
              state.period_covered?.[1] &&
              `${moment(state.period_covered?.[0]).format("ll")} - ${moment(
                state.period_covered?.[1]
              ).format("ll")} `}{" "}
            <br />
            Printed By : {auth.user.name} <br />
            Date/Time Printed : {moment().format("LLL")}
          </div>

          <MemorizeTable dependencies={[records, trans_types, payment_types]}>
            <div className="report-container">
              <table>
                <thead>
                  <tr>
                    <th rowSpan={2}>DATE</th>
                    {trans_types.map((type) => {
                      return (
                        <th
                          colSpan={payment_types?.length}
                          className="has-text-centered"
                        >
                          {type ? type : "ETC."}
                        </th>
                      );
                    })}
                  </tr>
                  <tr>
                    {trans_types.map((type) => {
                      return payment_types.map((payment) => {
                        return <th className="has-text-right">{payment}</th>;
                      });
                    })}
                  </tr>
                </thead>
                <tbody>
                  {records.map((record, index) => (
                    <tr key={index}>
                      <td className="has-text-centered">{record._id}</td>
                      {trans_types.map((type) => {
                        const item = record.items.find(
                          (o) => o.trans_type === type
                        );
                        return payment_types.map((payment) => {
                          const payment_item = (item?.payment_items || []).find(
                            (o) => o.payment_type === payment
                          );
                          return (
                            <td className="has-text-right">
                              {numberFormat(payment_item?.amount || 0)}
                            </td>
                          );
                        });
                      })}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    {trans_types.map((type) => {
                      const items = records
                        .flatMap((o) => o.items)
                        .filter((o) => o.trans_type === type);

                      return payment_types.map((payment) => {
                        const payment_items = items
                          .flatMap((o) => o.payment_items)
                          .filter((o) => o.payment_type === payment);

                        return (
                          <th className="has-text-right">
                            {numberFormat(
                              sumBy(payment_items, (o) => o.amount)
                            )}
                          </th>
                        );
                      });
                    })}
                  </tr>
                </tfoot>
              </table>
            </div>
          </MemorizeTable>

          <div className="report-heading m-t-1">
            <ReportFooter />
          </div>
        </div>
      </Container>
    </Content>
  );
}
